import { simplePath } from "../utils.js";
const UD_PEOPLE_PATH = "/v2/people/:organization/:id";
function get_people_ud_path(params) {
    return simplePath(UD_PEOPLE_PATH, params);
}
export { UD_PEOPLE_PATH, get_people_ud_path };
